<template>
  <CCard>
    <CCardHeader>
      <h4>Most started episodes</h4>
    </CCardHeader>
    <CCardBody>
      <div class="progress-group" v-for="(item, index) in newItems" :key="index">
        <div @click="goTo(item.id)" class="progress-group-header">
          <img :src="item.image_url || pixel" class="list_image sm-image" />
          <span class="title">{{ index + 1 }}. {{ item.title }}</span>
          <span class="ml-auto font-weight-bold">
            {{ item.listened_count }}
            <!-- <span class="text-muted small">({{ item.part }}%)</span> -->
          </span>
        </div>
        <div class="progress-group-bars">
          <CProgress class="progress-sm" :value="item.part" color="pinterest" />
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import { PIXEL_TRANSPARANT } from '../constants'
export default {
  name: 'WidgetTopTen',
  props: {
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      pixel: PIXEL_TRANSPARANT,
    }
  },
  computed: {
    newItems() {
      let largest = 0
      const items = this.items.map(item => {
        // calculate length of bar
        if (item.listened_count > largest) {
          largest = item.listened_count
        }
        item.part = Math.floor((item.listened_count / largest) * 100)
        return item
      })
      return items
    },
  },
  methods: {
    goTo(id) {
      this.$router.push({ path: `/podcasts/episodes/${id}` })
    },
  },
}
</script>

<style>
.progress-group:hover {
  cursor: pointer;
}

.list_image.sm-image {
  width: 24px;
  height: 24px;
  border: 1px solid #efefef;
  margin-right: 6px;
}
</style>
